<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="stati-patrimoniali-list-table">
    <template #column-key-totaleCapitaleInvestito="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-totaleCapitaleAcquisito="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-baseline="{ value }">
      {{ value ? 'Sì' : 'No' }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.stati-patrimoniali.edit', params: { statoPatrimonialeId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'crediti-imposta-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    crediti: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'month', label: 'Mese' },
        { key: 'baseline', label: 'Bilancio iniziale' },
        { key: 'totaleCapitaleInvestito', label: 'Totale capitale investito' },
        { key: 'totaleCapitaleAcquisito', label: 'Totale capitale acquisito' },
      ];
    },
    tableRows () {
      return (this.crediti || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
